// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-LinkImg-css__container--u0fXg","section":"src-constrains-LinkImg-css__section--7fwAj","linkContainer":"src-constrains-LinkImg-css__linkContainer--UBVYg"};